
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/chat",
      function () {
        return require("private-next-pages/admin/chat/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/chat"])
      });
    }
  